import { httpRequest } from "@services/http";
import { Pricesheet } from "@models/pricesheet.model";
import { PricesheetSerializer } from "@models/serializers/pricesheetSerializer";

export class CommandDeletePricesheet {
  async run(contractId: number, pricesheetId: number): Promise<Pricesheet> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/`;
    const response = await httpRequest<any>(url, { method: "DELETE" });
    return PricesheetSerializer.fromJson(response);
  }
}
